/**
 * 유저 대시보드 -> 참여한 설문
 *
 * @description
 *
 * @author hjkim
 * @constructor
 */
const MyParticipation = () => {
  return <div>My Participation</div>;
};

export default MyParticipation;
